import { FormFieldErrorDirective } from './form-field-error.directive';
import { FormFieldHintDirective } from './form-field-hint.directive';
import { FormFieldComponent } from './form-field.component';

export const FormFieldImports = [FormFieldComponent, FormFieldErrorDirective, FormFieldHintDirective];
